// extracted by mini-css-extract-plugin
export default {"container":"FormattedText_container__-pkTs","str":"FormattedText_str__+V5Sw","whiteSpaceNowrap":"FormattedText_whiteSpaceNowrap__I7ucq"};